<template>
	<div style="height: 100%;">
		<div class="comp">
			<div class="L">
				<div style="line-height: 36px;text-align: center;color: rgb(52, 52, 64);font-size: 14px;font-weight: bold;cursor: pointer;margin:0 auto 10px;background-color: rgb(246, 248, 255);border-radius: 8px;" @click="drawerCouponAdd_state = true">
					<div class="navLabel">赠送优惠券</div>
				</div>
				<div class="LItem" :class="curNavIndex===0?'active':''" @click="changeCurNavIndex(0)">
					<div class="navLabel">满减券</div> <div class="navValue">{{page0.total}}</div>
				</div>
				<div class="LItem" :class="curNavIndex===1?'active':''" @click="changeCurNavIndex(1)">
					<div class="navLabel">折扣券</div> <div class="navValue">{{page1.total}}</div>
				</div>
			</div>
			<div class="R">
				<!-- 满减   满减  满减  满减  满减  满减  满减  满减  满减  满减  满减  满减  满减   -->
				<div class="panel" v-show="curNavIndex===0">
					<div class="searchLine">
						<div class="searchLineL">
							<!-- <div class="searchItem" :class="curTab0NavIndex===0?'active':''" @click="changeCurTab0NavIndex(0)">
								<span>最新发布</span>
								<span v-if="curTab0NavIndex===0" class="searchItemActiveBar"></span>
							</div> -->
						</div>
						<div class="searchLineR">
							<!-- <el-input v-model="search0.keyword" @keyup.enter.native="changeSearch0" disabled placeholder="请输入关键字"></el-input> -->
						</div>
					</div>
					<div class="list" v-if="$public.isNull(tableData0)" style="background-color: #fff;">
						<div style="padding-top:60px;text-align: center;">暂无数据</div>
					</div>
					<div class="list" v-else>
						<el-table :data="tableData0">
							<el-table-column label="编号" width="50">
								<template slot-scope="scope">
									{{scope.$index+1}}
								</template>
							</el-table-column>
							<el-table-column label="名称" width="150" column-key="table4_1">
								<template slot-scope="scope">
									{{scope.row.coupon_name}}
								</template>
							</el-table-column>
							<el-table-column label="满减规格" column-key="table4_2" width="110">
								<template slot-scope="scope">
									满 {{scope.row.money_top}} 可用
								</template>
							</el-table-column>
							<el-table-column label="优惠券码" column-key="table4_2" width="80">
								<template slot-scope="scope">
									{{scope.row._no}}
								</template>
							</el-table-column>
							<el-table-column label="类型" width="80" column-key="table4_1">
								<template slot-scope="scope">
									<div v-for="str in scope.row.coupon_type" :key="str">
										{{str===1?'商品':''}}
										{{str===2?'洗美':''}}
										{{str===3?'病例':''}}
										{{str===4?'疫苗驱虫':''}}
										{{str===5?'医疗服务':''}}
										{{str===6?'寄养':''}}
										{{str===7?'挂号':''}}
										{{str===8?'活体':''}}
										{{str===9?'虚拟':''}}
										{{str===10?'订金':''}}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="领取时间" width="100" column-key="table4_1" >
								<template slot-scope="scope">
									<span>{{$public.FTime(scope.row.receive_time,"YYYY-MM-DD")}}</span>
								</template>
							</el-table-column>
							<!-- <el-table-column label="有效期" width="110">
								<template slot-scope="scope">
									{{$public.FTime(scope.row.use_start_time,"YYYY-MM-DD")}} -- {{$public.FTime(scope.row.use_end_time,"YYYY-MM-DD")}}
								</template>
							</el-table-column> -->
							<el-table-column label="使用时间" width="100" column-key="table4_1">
								<template slot-scope="scope">
									{{$public.FTime(scope.row.use_time,"YYYY-MM-DD")}}
								</template>
							</el-table-column>
							<el-table-column label="状态" width="70">
								<template slot-scope="scope">
									<span v-if="scope.row.use_status==0" style="color:#999">不可用</span>
									<span v-if="scope.row.use_status==1" style="color:#f00">未使用</span>
									<span v-if="scope.row.use_status==2" style="color:#000">已使用</span>
									<span v-if="scope.row.use_status==3" style="color:#999">已过期</span>
								</template>
							</el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click='curItem=scope.row;drawerCouponSee_state=true;'>查看</el-button>
									<el-button type="text" size="small" @click='curItem=scope.row;drawerCouponEdit_state=true;'>编辑</el-button>
									<i class="el-icon-view" slot="reference" style="font-size: 20px;margin-left: 10px;color:#577BFF;" @click="curItem=scope.row;compCustomRecord_state=true"></i>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagePosi">
							<page style="padding:10px 0;" :page="page0.page" :total="page0.total" @change="changePage0"></page>
						</div>
					</div>
				</div>
				<!-- 折扣   折扣  折扣  折扣  折扣  折扣  折扣  折扣  折扣  折扣  折扣  折扣    -->
				<div class="panel" v-show="curNavIndex===1">
					<div class="searchLine">
						<div class="searchLineL">
							<!-- <div class="searchItem" :class="curTab0NavIndex===0?'active':''" @click="changeCurTab0NavIndex(0)">
								<span>最新发布</span>
								<span v-if="curTab0NavIndex===0" class="searchItemActiveBar"></span>
							</div> -->
						</div>
						<div class="searchLineR">
							<el-input v-model="search1.keyword" @keyup.enter.native="changeSearch1" disabled></el-input>
						</div>
					</div>
					<div class="list" v-if="$public.isNull(tableData1)" style="background-color: #fff;">
						<div style="padding-top:60px;text-align: center;">暂无数据</div>
					</div>
					<div class="list" v-else>
						<el-table :data="tableData1">
							<el-table-column label="编号" width="50">
								<template slot-scope="scope">
									{{scope.$index+1}}
								</template>
							</el-table-column>
							<el-table-column label="名称" width="150" column-key="table4_1">
								<template slot-scope="scope">
									{{scope.row.coupon_name}}
								</template>
							</el-table-column>
							<el-table-column label="满减规格" column-key="table4_2" width="110">
								<template slot-scope="scope">
									满 {{scope.row.money_top}} 可用
								</template>
							</el-table-column>
							<el-table-column label="优惠券码" column-key="table4_2" width="80">
								<template slot-scope="scope">
									{{scope.row._no}}
								</template>
							</el-table-column>
							<el-table-column label="类型" width="80" column-key="table4_1">
								<template slot-scope="scope">
									<div v-for="str in scope.row.coupon_type" :key="str">
										{{str===1?'商品':''}}
										{{str===2?'洗美':''}}
										{{str===3?'病例':''}}
										{{str===4?'疫苗驱虫':''}}
										{{str===5?'医疗服务':''}}
										{{str===6?'寄养':''}}
										{{str===7?'挂号':''}}
										{{str===8?'活体':''}}
										{{str===9?'虚拟':''}}
										{{str===10?'订金':''}}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="领取时间" width="100" column-key="table4_1" >
								<template slot-scope="scope">
									<span>{{$public.FTime(scope.row.receive_time,"YYYY-MM-DD")}}</span>
								</template>
							</el-table-column>
							<!-- <el-table-column label="有效期" width="110">
								<template slot-scope="scope">
									{{$public.FTime(scope.row.use_start_time,"YYYY-MM-DD")}} -- {{$public.FTime(scope.row.use_end_time,"YYYY-MM-DD")}}
								</template>
							</el-table-column> -->
							<el-table-column label="使用时间" width="100" column-key="table4_1">
								<template slot-scope="scope">
									{{$public.FTime(scope.row.use_time,"YYYY-MM-DD")}}
								</template>
							</el-table-column>
							<el-table-column label="状态" width="70">
								<template slot-scope="scope">
									<span v-if="scope.row.use_status==0" style="color:#999">不可用</span>
									<span v-if="scope.row.use_status==1" style="color:#f00">未使用</span>
									<span v-if="scope.row.use_status==2" style="color:#000">已使用</span>
									<span v-if="scope.row.use_status==3" style="color:#999">已过期</span>
								</template>
							</el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click='curItem=scope.row;drawerCouponSee_state=true;'>查看</el-button>
									<el-button type="text" size="small" @click='curItem=scope.row;drawerCouponEdit_state=true;'>编辑</el-button>
									<i class="el-icon-view" slot="reference" style="font-size: 20px;margin-left: 10px;color:#577BFF;" @click="curItem=scope.row;compCustomRecord_state=true"></i>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagePosi">
							<page style="padding:10px 0;" :page="page1.page" :total="page1.total" @change="changePage1"></page>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="drawerCouponSee_state">
			<drawerCouponSee :curItem="curItem" @submit="drawerCouponSee_state=false"></drawerCouponSee>
		</div>
		<div v-if="drawerCouponAdd_state">
			<drawerCouponAdd :memberId="$route.query.id" @submit="submit_drawerCouponAdd"></drawerCouponAdd>
		</div>
		<div v-if="drawerCouponEdit_state">
			<drawerCouponEdit :row="curItem" @submit="submit_drawerCouponEdit"></drawerCouponEdit>
		</div>
		<!-- 自定义记录 -->
		<div v-if="compCustomRecord_state">
			<compCustomRecord :linkId="curItem._id" :type="6" @submit="compCustomRecord_state=false"></compCustomRecord>
		</div>
	</div>
</template>

<script>
	import drawerCouponSee from "@/components/coupon/drawer_couponSee.vue"
	import page from "@/components/page.vue"
	import drawerCouponAdd from "./drawer/drawer_couponAdd.vue"
	import drawerCouponEdit from "./drawer/drawer_couponEdit.vue"
	import compCustomRecord from "@/components/compCustomRecord.vue"
	export default {
		components:{page,drawerCouponSee,drawerCouponAdd,drawerCouponEdit,compCustomRecord},
		data() {
			return {
				curNavIndex:0,
				
				// 满减
				search0:{
					keyword:'',
					sort:'',
				},
				page0:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData0:[],
				// 折扣
				search1:{
					keyword:'',
					sort:'',
				},
				page1:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData1:[],
				// 详情
				drawerCouponSee_state:false,
				curItem:{},
				// 赠送优惠券
				drawerCouponAdd_state:false,
				// 编辑优惠券
				drawerCouponEdit_state:false,
				// 自定义记录
				compCustomRecord_state:false,
			}
		},
		computed:{
			
		},
		created(){
			
		},
		mounted(){
			this.getTableData0List()
			this.getTableData1List()
		},
		methods:{
			submit_drawerCouponAdd(obj){
				this.drawerCouponAdd_state = false;
				if(obj.type==='success'){
					this.changeCurNavIndex(this.curNavIndex)
				}
			},
			submit_drawerCouponEdit(obj){
				this.drawerCouponEdit_state = false;
				if(obj.type==='success'){
					this.changeCurNavIndex(this.curNavIndex)
				}
			},
			
			changeCurNavIndex(i){
				this.curNavIndex=i;
				if(i===0){this.getTableData0List()} // 满减 
				if(i===1){this.getTableData1List()} // 折扣
			},
			// 满减 满减 满减 满减 满减 满减 满减 满减 满减 
			changeSearch0(){
				this.page0.page=1;
				this.getTableData0List()
			},
			changePage0(num){
				this.page0.page=num;
				this.getTableData0List()
			},
			getTableData0List(){
				let params = {
					"userId": this.$route.query.id, // 用户id
					activityType:1, // 0：全部、1：满减活动、2：折扣活动
					useStatus:-1, // -1:全部 0：不可用，1：未使用 2：已使用 3：已过期
					"pageIndex": this.page0.page,
					"pageSize": this.page0.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Member/coupon/list', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.tableData0 = res.data.list;
						this.page0.total = res.data.count;
					}
				})
			},
			// 折扣 折扣 折扣 折扣 折扣 折扣 折扣 折扣 折扣 折扣 
			changeSearch1(){
				this.page1.page=1;
				this.getTableData1List()
			},
			changePage1(num){
				this.page1.page=num;
				this.getTableData1List()
			},
			getTableData1List(){
				let params = {
					"userId": this.$route.query.id, // 用户id
					activityType:2, // 0：全部、1：满减活动、2：折扣活动
					useStatus:-1, // -1:全部 0：不可用，1：未使用 2：已使用 3：已过期
					"pageIndex": this.page1.page,
					"pageSize": this.page1.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Member/coupon/list', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.tableData1 = res.data.list;
						this.page1.total = res.data.count;
					}
				})
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.comp{
		display: flex;margin-top:16px;height: 100%;
		.L{
			width:272px;background-color: #fff;border-radius: 16px;flex-shrink: 0;padding:24px;box-sizing: border-box;margin-right: 16px;
			.LItem{
				line-height: 36px;display: flex;color:$color333;font-size: 14px;font-weight: bold;cursor: pointer;margin-bottom: 10px;
				&.active{
					color:#577BFF;background-color: #F6F8FF;
				}
				.navLabel{
					width:50%;text-align: center;
				}
				.navValue{
					width:50%;text-align: center;
				}
			}
		}
		.R{
			width:100%;
			.panel{
				position: relative;height: 100%;
				.searchLine{
					display: flex;justify-content: space-between;background-color: #fff;border-radius: 16px 16px 0px 0px;padding:20px 32px 20px;position: absolute;width:100%;box-sizing: border-box;top:0;z-index: 1;
					.searchLineL{
						display: flex;padding-top: 16px;
						.searchItem{
							font-size: 14px;color:$color333;margin-right: 40px;cursor: pointer;
							&.active{
								color:#577BFF;
							}
							.searchItemActiveBar{
								display: block;width:18px;height: 4px;background: linear-gradient(135deg, #4BB2FF 0%, #466BFF 100%);border-radius: 3px;margin:8px auto 0;
							}
						}
					}
					.searchLineR{
						
					}
				}
				.list{
					padding-top:80px;border-radius: 16px;overflow: auto;height: calc(100% - 80px);background-color: #fff;
					.item{
						background-color: #fff;border-radius: 16px;margin-bottom:16px;padding:32px;display: flex;
						.avatarBox{
							.avatar{
								width:56px;height: 56px;border-radius: 50%;margin-right: 16px;
							}
						}
						.avatarBoxR{
							.originalName{
								font-size: 14px;color:$color333;padding-bottom:5px
							}
							.originalTime{
								font-size: 12px;color:$color999;
							}
							.originalTag{
								display: flex;padding-top:10px;
								.tagItem{
									background-color: #F7F9FA;border-radius: 12px;margin-right: 20px;display: flex;height: 22px;padding:3px 10px 3px 3px;box-sizing: border-box;line-height: 16px;
									.tagIcon{
										width:16px;height: 16px;margin-right: 5px;
									}
									.tagText{
										font-size: 12px;color:#4062E7;
									}
								}
							}
							.originalWord{
								padding-top:10px;padding-right: 50px;
								.word{
									font-size: 14px;color:$color333;line-height: 22px;
								}
							}
							.originalImg{
								padding-top:10px;padding-right: 30px;overflow: hidden;white-space: nowrap;width:625px;
								.originalImgItem{
									width:104px;height: 104px;margin-right: 4px;
								}
							}
							.originalBtn{
								display: flex;padding-top:16px;
								.num1{
									font-size: 14px;color:#333;margin-right: 16px;
								}
								.num2{
									font-size: 14px;color:$color999;margin-right: 32px;
								}
								.btn{
									font-size: 14px;color:#577BFF;margin-right: 32px;cursor: pointer;
								}
							}
						}
					}
				}
				.list1{
					padding:62px 32px 0 32px;display: flex;flex-wrap: wrap;background-color: #fff;border-radius: 16px;overflow: auto;max-height: calc(100% - 68px);align-items: flex-start;
					.item1{
						width:256px;padding-top:32px;height: 238px;margin-right: 16px;
						.item1ImgBox{
							position: relative;font-size: 0;width:256px;
							.item1Img{
								width:255px;height: 144px;
							}
							.item1Time{
								line-height: 36px;color:#fff;text-align: right;padding:0 16px;background-color: rgba(0, 0, 0, 0.5);position: absolute;bottom:0;width:100%;left:0;box-sizing: border-box;font-size: 14px;
							}
						}
						.item1Desc{
							font-size: 14px;color:$color333;padding: 16px 0;display: flex;justify-content: space-between;
							.text{
								width:100%;padding-right: 20px;
							}
							.more{
								width:20px;height: 20px;cursor: pointer;flex-shrink: 0;
							}
						}
						.item1BtnBox{
							display: flex;flex-wrap: wrap;
							.item1Btn{
								font-size: 14px;color:$color333;width:50%;padding-bottom:10px;
								span{
									margin-right: 8px;
								}
							}
						}
					}
				}
				.list6{
					padding:62px 32px 0 32px;background-color: #fff;border-radius: 16px;overflow: auto;max-height: calc(100% - 68px);
					.item6{
						padding:32px 0 0;
						.item6Date{
							font-size: 18px;color:$color333;font-weight: 600;
						}
						.item6Content{
							padding:16px 0 0;flex-wrap: wrap;display: flex;
							.item6ImgBox{
								position: relative;font-size: 0;width:103px;margin-right: 4px;margin-bottom: 16px;border-radius: 4px;
								.item6Img{
									width:103px;height: 103px;
								}
								.item6Time{
									line-height:24px;color:#fff;text-align: center;background-color: rgba(0, 0, 0, 0.5);position: absolute;bottom:0;width:100%;left:0;box-sizing: border-box;font-size: 12px;
								}
							}
						}
						
					}
				}
			}
			.pagePosi{
				width:100%;text-align: right;background-color: #fff;border-radius: 8px;padding:0 10px;box-sizing: border-box;position: relative;z-index: 1;
			}
		}
	}
</style>
